import beziers from './beziers';
import breakpoints from './breakpoints';
import colors from './colors';
import {
  accordion,
  banner,
  buttonSize,
  button,
  cards,
  combobox,
  featureGrid,
  heading,
  hero,
  link,
  logoSection,
  nav,
  paper,
  peopleSection,
  quote,
  tileSize,
  video,
  wave,
} from './components';
import * as shared from './shared/index';
import fonts from './fonts';
import fontSizes from './font-sizes';
import keyframe from './keyframes';
import radii from './radii';
import shadows from './shadows';
import space from './space';
import typography from './typography';
import zIndices from './z-indices';
import type { Theme } from '../types/lucid-theme';

export const theme: Theme = {
  ...fonts,
  beziers,
  breakpoints,
  colors,
  fontSizes,
  radii,
  shadows,
  space,
  zIndices,
  // keyframe
  keyframe,
  // shared
  shared,
  // components
  accordion,
  banner,
  buttonSize,
  buttons: button,
  cards,
  combobox,
  featureGrid,
  headings: heading,
  hero,
  link,
  logoSection,
  nav,
  paper,
  peopleSection,
  quote,
  tileSize,
  typography,
  video,
  wave,
};

export default theme;
